import { useEffect, useState, useCallback } from 'react';
import { useCookies } from 'react-cookie';
import { useDispatch, useSelector } from 'react-redux';
import { setUserData } from './store/userSlice';
import { Helmet } from 'react-helmet';
import { jwtDecode } from 'jwt-decode';

import './styles/fonts.css';
import HomePage from './components/home';
import ListUser from './components/user/listUser';
import ListCC from './components/cc/listCC';
import ListSolp from './components/solped/listSolp';
import ListSolpDeta from './components/solped/listSolpDeta';
import ListocDeta from './components/solped/listOcDeta';
import ListPosi from './components/posi/listPosi';
import ListInve from './components/inve/listInve';
import ListTrac from './components/trac/listTrac';
import Manual from './components/manual';
import ListStat from './components/stat/listStat';
import ListStatInvoice from './components/stat/lisStatInvoice';
import ListLedger from './components/ledger/listLedger';
import ListBudg from './components/budg/listBudg';
import ListInvoDeta from './components/invo/listInvoDeta';
import DSP from './components/dsp';
import DOC from './components/doc';
import DocuSolp from './components/solped/docuSolp';
import DocuOrde from './components/orde/docuOrde';
import ListOrde from './components/orde/listOrde';
import StatOrde from './components/stat/statOrde';
import { ListSmDeta } from './components/solped/listSMDeta';


import { approveSolped, getSolpedApprovalValidation } from './utils/functions';
import { apiurl } from './utils/constants';
import ListLInvoice from './components/invo/listInvoice';
const { loginORMbyGoogle, loginORMbyCookie } = require('./utils/functions');

function App() {
	const [isSignedIn, setIsSignedIn] = useState(false);
	const [isRole, setIsRole] = useState(0);
	const [isGapiLoaded, setIsGapiLoaded] = useState(false);
	const dispatch = useDispatch();
	const { iden, mail, name, avat, back, dark, comp, budg, sap_user } = useSelector((state) => state.user);
	const [cookies, setCookie, removeCookie] = useCookies();

	const urlParams = new URLSearchParams(window.location.search);
	const dspParam = urlParams.get('dsp');
	const docParam = urlParams.get('doc');
	const db = urlParams.get('db');
	const approve = urlParams.get('approve');
	const billParam = urlParams.get('bill');
	const orm = urlParams.get('orm');

	if (!dspParam && !docParam) {
		import('./styles/App.css');
		import('./styles/light.css');
		import('./styles/dark.css');
	}

	useEffect(() => {
		const initializeUser = async () => {
			if (cookies.mail) {
				const user = await loginORMbyCookie(cookies.mail);
				if (user.error) {
					console.log(user.error);
					return;
				}
				dispatch(setUserData(user));
				setIsSignedIn(true);
				setIsRole(user.role);
			}
			setIsGapiLoaded(true);
		};
		initializeUser();
	}, [cookies.mail, dispatch]);

	if (!isGapiLoaded && (!approve && !orm)) {
		return <div>Cargando...</div>;
	}

	const onSuccess = async (response) => {

		const user = await loginORMbyGoogle(response);
		if (!user) { console.log('loginORMbyGoogle devolvió vacío'); return; }
		if (user?.error) {
			console.log(user.error);
			return;
		}

		Object.keys(user).forEach(key => {
			setCookie(key, user[key], { path: '/' });
		});

		dispatch(setUserData(user));
		setIsSignedIn(true);
		setIsRole(user.role);

	};

	const onFailure = (response) => {
		console.log('Login failed:', response);
	}

	const handleLogout = () => {
		setIsSignedIn(false);
		Object.keys(cookies).forEach(cookie => removeCookie(cookie, { path: '/' }));
		dispatch(setUserData({}));
	};

	return (
		<div className="App">
			{
				(!approve && !orm)
					? (isSignedIn
						? (<Menu isRole={isRole} handleLogout={handleLogout} state={{ iden, mail, name, avat, back, dark, comp, budg, sap_user }} />)
						: (<Home onSuccess={onSuccess} onFailure={onFailure} />))
					: (billParam ? <ApproveBill approve={approve} bill={billParam} sapDB={db} /> : (<Approve approve={approve} orm={orm} sapDB={db} />))
			}
		</div>
	);
}

function Home({ onSuccess, onFailure }) {
	const clientId = '208652130630-v5uud3qoi2obo31o3qgj33qfreuik6rl.apps.googleusercontent.com';

	const initGoogleSignIn = () => {
		if (!window.google || !window.google.accounts) {
			console.error("Google Identity Services no está disponible.");
			return;
		}

		window.google.accounts.id.initialize({
			client_id: clientId,
			callback: (response) => {
				if (response.credential) {
					console.log(jwtDecode(response.credential));
					onSuccess(jwtDecode(response.credential));
				} else {
					onFailure(response);
				}
			},
			use_fedcm_for_prompt: true, // Asegúrate de que esto esté activado
			itp_support: true, // Soporte para prevenir el tracking en ciertas situaciones
		});

		// Aquí es donde se pasa notification al callback
		window.google.accounts.id.prompt((notification) => {
			if (notification.isNotDisplayed() || notification.isSkippedMoment()) {
				console.log("No se mostró el prompt de FedCM. Puede requerir interacción del usuario.");
				alert("No pudimos iniciar sesión automáticamente. Por favor, asegúrese de que su navegador permite los pop-ups y cookies de terceros.");
				console.log("chrome://settings/content/federatedIdentityApi");
			}
		});
	};

	const handleLoginClick = (event) => {
		event.preventDefault();
		initGoogleSignIn();
	};

	return (
		<form>
			<Helmet>
				<html lang="es" translate="no" />
				<body className={'light-mode'} translate="no" />
			</Helmet>
			<main className='home'>
				<div className='logo'></div>
				<div>
					<p>Bienvenido!</p>
					<p>Recuerde que necesita una cuenta Bailacthor para ingresar.</p>
				</div>
				<div>
					<button onClick={handleLoginClick}>Iniciar sesion con Google</button>
				</div>
			</main>
		</form>
	);
}

function Approve({ approve, orm, sapDB }) {

	const [solp, setSolp] = useState('');
	//const [iden, setIden] = useState('');
	const [share, setShare] = useState(0);
	const [status, setStatus] = useState(100);
	const [validationError, setValidationError] = useState(null);

	const loadSolped = useCallback(async (iden, mail, sapDB) => {
		try {
			const response = await fetch(apiurl + 'queryAux', {
				method: 'POST',
				credentials: 'include',
				headers: { 'Content-Type': 'application/json' },
				body: JSON.stringify({
					user: mail,
					sapDB: sapDB,
					query: `SELECT soli.iden solp, MD5(CONCAT('BailacORM',soli.iden)) share,
							IF(soli.approver IS NULL, 0, 1) status, ritem.iden ritem_iden,
							ritem.ware, ritem.amou, ritem.cost, iitem.code
						FROM req__soli soli
						LEFT JOIN req__item ritem ON ritem.soli = soli.iden
						LEFT JOIN inv__item iitem ON iitem.code = ritem.item
						WHERE MD5(CONCAT('orm',soli.iden)) = '${orm}' `
				})
			});

			if (response.ok) {
				const data = await response.json();
				if (!data.length) {
					setStatus(-4);
					return;
				}
				const approvalValidation = getSolpedApprovalValidation(data);
				setSolp(data[0].solp);
				setShare(data[0].share);
				if (data[0].status) setStatus(1);
				else if (!approvalValidation.valid) {
					setValidationError(approvalValidation);
					setStatus(-5);
				}
				else setStatus(await approveSolped(data[0].solp, iden, mail, sapDB, 'mail')); // status 1 error - status 2 aprobado - status 3 no tiene permisos

			} else {
				setStatus(-3);
				console.error('Error al obtener los CC');
			}
		} catch (error) {
			setStatus(-4);
			console.error('Error en la solicitud:', error);
		}
	}, [orm])

	const loadUser = useCallback(async () => {
		try {
			const response = await fetch(apiurl + 'getMail', {
				method: 'POST',
				credentials: 'include',
				headers: { 'Content-Type': 'application/json' },
				body: JSON.stringify({
					iden_md5: approve
				})
			});

			if (response.ok) {
				const data = await response.json();
				//setIden(data.iden);
				loadSolped(data.iden, data.mail, sapDB);
			} else {
				setStatus(-1);
				console.error('Error al obtener los getMail');
			}
		} catch (error) {
			setStatus(-2);
			console.error('Error en la solicitud:', error);
		}
	}, [approve, sapDB, loadSolped])

	useEffect(() => {
		loadUser();
	}, [loadUser])

	return (
		<form>
			<Helmet>
				<html lang="es" translate="no" />
				<body className={'light-mode'} translate="no" />
			</Helmet>
			{<dialog open>
				<div className={status === 2 ? "gre" : status < 1 ? "red" : "blu"}>
					<p data-icon={status === 2 ? ("") : status < 1 ? ("") : ("")}>
						{status === 2 ? (<div><div>{`Solicitud ${solp} aprobada.`}</div><br></br><div>Puede ver la solicitud completa aquí: <a href={`${window.location.origin}?sp=${share}`}>{`${window.location.origin}?sp=${share}`}</a></div></div>)
							: status === 100 ? (<div>Autorizando...</div>)
									: validationError ? (<div>
										<div>No se puede aprobar esta solicitud</div>
										<br></br>
										{validationError.reasons.map((reason) => <div key={reason}>{reason}</div>)}
									</div>)
										: (<div>
										<div>Error al aprobar esta solicitud</div>
									<br></br>
									<div>{`Código : ${status}.`}</div>
								</div>)
						}
					</p>
				</div>
			</dialog>}
		</form>
	)
}

function ApproveBill({ approve, bill, sapDB }) {

	const [status, setStatus] = useState(1);
	const [folioNum, setFolioNum] = useState('');

	const setApprover = useCallback(async () => {
		try {

			const response = await fetch(apiurl + 'appr_bill', {
				method: 'POST',
				credentials: 'include',
				headers: { 'Content-Type': 'application/json' },
				body: JSON.stringify({
					sapDB, approve, bill
				})
			});

			if (response.ok) {
				const data = await response.json();
				if (data.error === 1) {
					setStatus(-1);
					return -1;
				} else {
					setFolioNum(data.folioNum);
					setStatus(2);
					return 2;
				}
			} else {
				setStatus(-1);
				return -1; // error
			}

		} catch (error) {
			console.error('Error en la solicitud:', error);
			setStatus(-2);
			return -2; // error de conexión
		}

	}, [approve, bill, sapDB])

	useEffect(() => {
		setApprover();
	}, [setApprover])

	return (
		<form>
			<Helmet>
				<html lang="es" translate="no" />
				<body className={'light-mode'} translate="no" />
			</Helmet>
			{<dialog open>
				<div className={status === 2 ? "gre" : status < 1 ? "red" : "blu"}>
					<p data-icon={status === 2 ? ("") : status < 1 ? ("") : ("")}>
						{status === 2 ? (<div><div>{`Factura ${folioNum} aprobada.`}</div><br></br><div>Puede ver la factura completa <a href={`${window.location.origin}?db=${sapDB}&bill=${bill}`}>aquí</a></div></div>)
							: status === 100 ? (<div>Autorizando...</div>)
								: (<div>
									<div>Error al aprobar esta factura</div>
									<br></br>
									<div>{`Código : ${status}.`}</div>
								</div>)
						}
					</p>
				</div>

			</dialog>}
		</form>
	)
}

function Menu({ isRole, handleLogout, state }) {

	const imagePaths = ['bg0.png', 'bg1.png', 'bg2.png', 'bg3.png', 'bg4.png', 'bg5.png'];
	const images = imagePaths.map(path => require(`./img/${path}`));
	const [selectedImageIndex, setSelectedImageIndex] = useState(0);
	const [dialogOpen, setDialogOpen] = useState(false);
	const [statSAP, setStatSap] = useState(0);
	const [canBill, setCanBill] = useState(false);
	const dispatch = useDispatch();
	const { iden, mail, name, avat, back, dark, comp, sapDB, budg, sap_user } = useSelector((state) => state.user);

	useEffect(() => {
		if (!iden || !mail) return;

		const checkCanBill = async () => {
			try {
				const response = await fetch(apiurl + 'queryAux', {
					method: 'POST',
					credentials: 'include',
					headers: { 'Content-Type': 'application/json' },
					body: JSON.stringify({
						user: mail,
						query: `SELECT COUNT(*) AS cnt FROM req__cent WHERE bill = ${Number(iden)}`
					})
				});

				if (response.ok) {
					const data = await response.json();
					setCanBill(Number(data?.[0]?.cnt || 0) > 0);
				} else {
					setCanBill(false);
				}
			} catch (error) {
				console.error('Error en checkCanBill:', error);
				setCanBill(false);
			}
		};

		checkCanBill();
	}, [iden, mail]);

	const [selectedComponent, setSelectedComponent] = useState([]);

	const urlParams = new URLSearchParams(window.location.search);
	const spParam = urlParams.get('sp');
	const billParam = urlParams.get('bill');
	const smParam = urlParams.get('sm');
	const dspParam = urlParams.get('dsp');
	const docParam = urlParams.get('doc');
	const compParam = urlParams.get('comp');
	const db = urlParams.get('db');

	const messageComponent =
		isRole === 0 ? (<main><nav><article className='blu'> <h2>Pendiente</h2> <p data-icon=''>Ya estás en la lista de espera, te avisaremos cuando tu cuenta sea aprobada.</p> </article> </nav></main>)
			: isRole === -1 ? (<main><nav><article className='red'><h2>Inactivo</h2><p data-icon=''>Tu cuenta ha sido desactivada, contacta con el administrador para reactivarla.</p></article></nav></main>)
				: (<></>);

	const handleMenuItemClick = (componentOrObj, iden = null, solped = null, filtr = null, typeDocu = 'solped') => {
	console.log('handleMenuItemClick ',componentOrObj);
    // Si es un objeto, usar ese formato
    if (typeof componentOrObj === 'object' && componentOrObj !== null) {
        setSelectedComponent({ 
	            component: componentOrObj.component ?? null, 
	            iden: componentOrObj.iden ?? null, 
	            solped: componentOrObj.solped ?? null, 
	            filtr: componentOrObj.filtr ?? null, 
	            typeDocu: componentOrObj.typeDocu ?? 'solped',
	            docu: componentOrObj.docu ?? null, 
	        });
	    } else {
	        // Si es string/null, usar formato antiguo
	        setSelectedComponent({ component: componentOrObj, iden, solped, filtr, typeDocu });
	    }
	};

	const setSelectComp = async (val) => {

		try {
			const response = await fetch(apiurl + 'queryAux', {
				method: 'POST',
				headers: { 'Content-Type': 'application/json' },
				body: JSON.stringify({ query: `UPDATE sys__user SET comp=${val} WHERE mail='${mail}' `, user: mail }),
			});

			if (response.ok) {

				let sapDB_aux = '';
				switch (val) {
					case "0": sapDB_aux = "CLTSTTHORINGENIERIA"; break;
					case "1": sapDB_aux = "CLPRDTHORINGENIERIA"; break;
					case "2": sapDB_aux = "CLPRDTHORSERVYASESORIAS"; break;
					case "3": sapDB_aux = "CLPRDTHORTRANSPYLOGISTICA"; break;
					default:
						break;
				}

				dispatch(setUserData({ iden, role: isRole, mail, name, avat, back, dark, comp: val, sapDB: sapDB_aux, budg, sap_user }));
				handleMenuItemClick(null);
				window.location.reload();

			} else {
				throw new Error('Error en la solicitud POST');
			}
		} catch (error) {
			console.log('error al updatear la DB ', error);
		}
	}

	const openDialog = () => {
		setDialogOpen(true);
	};

	const closeDialog = () => {
		setDialogOpen(false);
	};

	const changeImage = async (index) => {

		setSelectedImageIndex(index);
		const response = await fetch(apiurl + 'tablePUT', {
			method: 'POST',
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify({ table: 'sys__user', iden: `mail='${mail}'`, fields: `back='${imagePaths[index]}'`, user: mail }),
		});

		if (response.ok) {
			//const data = await response.json();
			dispatch(setUserData({ iden: iden, role: isRole, mail: mail, name: name, avat: avat, back: imagePaths[index], dark, comp, sapDB, budg, sap_user }));
		} else {
			throw new Error('Error en la solicitud POST');
		}

	};

	const handleCBX = async (event) => {

		const cbx = (event.target.checked) ? 1 : 0;

		const response = await fetch(apiurl + 'tablePUT', {
			method: 'POST',
			credentials: 'include',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify({ table: 'sys__user', iden: `mail='${mail}'`, fields: `dark='${cbx}'`, user: mail }),
		});

		if (response.ok) {
			//const data = await response.json();
			dispatch(setUserData({ iden: iden, role: isRole, mail: mail, name: name, avat: avat, back: back, dark: cbx, comp, sapDB, budg, sap_user }));
		} else {
			throw new Error('Error en la solicitud POST');
		}
	};

	const getComponent = () => {
		switch (selectedComponent.component) {
			case 'listUser':
				return <ListUser key={Math.floor(Math.random() * 10000)} />;
			case 'listPosi':
				return <ListPosi key={Math.floor(Math.random() * 10000)} />;
			case 'listCC':
				return <ListCC key={Math.floor(Math.random() * 10000)} />;
			case 'listInve':
				return <ListInve key={Math.floor(Math.random() * 10000)} />
			case 'listBudg':
				return <ListBudg key={Math.floor(Math.random() * 10000)} />
			case 'listSolp':
				return <ListSolp onMenuItemClick={handleMenuItemClick} key={Math.floor(Math.random() * 10000)} filtr={selectedComponent.filtr} />;
			case 'listOrde':
				return <ListOrde onMenuItemClick={handleMenuItemClick} key={Math.floor(Math.random() * 10000)} />;
			case 'statOrde':
				return <StatOrde onMenuItemClick={handleMenuItemClick} key={Math.floor(Math.random() * 10000)} />;
			case 'listSolpDeta':
				return <ListSolpDeta onMenuItemClick={handleMenuItemClick} iden={selectedComponent.iden} docu={selectedComponent.docu} key={Math.floor(Math.random() * 10000)} filtr={selectedComponent.filtr} />;
			case 'docuSolp':
				return <DocuSolp onMenuItemClick={handleMenuItemClick} iden={selectedComponent.iden} key={Math.floor(Math.random() * 10000)} />;
			case 'docuOrde':
				return <DocuOrde onMenuItemClick={handleMenuItemClick} iden={selectedComponent.iden} solped={selectedComponent.solped} typeDocu={selectedComponent.typeDocu} key={Math.floor(Math.random() * 10000)} />;
			case 'listOcDeta':
				return <ListocDeta onMenuItemClick={handleMenuItemClick} oc={selectedComponent.iden} solped={selectedComponent.solped} typeDocu={selectedComponent.typeDocu} key={Math.floor(Math.random() * 10000)} />;
			case 'listTrac':
				return <ListTrac key={Math.floor(Math.random() * 10000)} />
			case 'manual':
				return <Manual />;
			case 'listStat':
				return <ListStat onMenuItemClick={handleMenuItemClick} key={Math.floor(Math.random() * 10000)} />
			case 'listStatInvoice':
				return <ListStatInvoice onMenuItemClick={handleMenuItemClick} key={Math.floor(Math.random() * 10000)} />
			case 'listLedger':
				return <ListLedger key={Math.floor(Math.random() * 10000)} />;
			case 'listInvoice':
				return <ListLInvoice onMenuItemClick={handleMenuItemClick} key={Math.floor(Math.random() * 10000)} filtr={selectedComponent.filtr} />;
			case 'listInvoDeta':
				return <ListInvoDeta onMenuItemClick={handleMenuItemClick} docu={selectedComponent.docu} iden={selectedComponent.iden} key={Math.floor(Math.random() * 10000)} filtr={selectedComponent.filtr} />;
			case 'listSmDeta':
				return <ListSmDeta onMenuItemClick={handleMenuItemClick} iden={selectedComponent.iden} key={Math.floor(Math.random() * 10000)} />;
			default:
				return <HomePage setSelectedComponent={setSelectedComponent} isRole={isRole} canBill={canBill} />;
		}
	};


	const statusSAP = useCallback(async () => {
		try {
			const response = await fetch(apiurl + 'sapLoginWeb', {
				method: 'POST',
				credentials: 'include',
				headers: { 'Content-Type': 'application/json' },
				body: JSON.stringify({
					sapDB: sapDB
				})
			});

			if (response.ok) {
				const datat = await response.json();
				setStatSap(datat.token);
			}

		} catch (error) {
			console.error('Error en la solicitud statusSAP:', error);
		}
	}, [sapDB])

	const backgroundImage = back ? `url(${require(`./img/${back}`)})` : `url(${images[selectedImageIndex]})`;
	const styleString = `background-image: ${backgroundImage};`;

	const getMD5 = useCallback(async (spParam, type) => {
		if (type === 'bill' && spParam) handleMenuItemClick('listInvoDeta', spParam);
		else if (type === 'sm' && spParam) handleMenuItemClick('listSmDeta', spParam);
		else {
			const response = await fetch(apiurl + 'getMD5', {
				method: 'POST',
				headers: { 'Content-Type': 'application/json' },
				body: JSON.stringify({ spParam: spParam, user: mail, type }),
			});

			if (response.ok) {
				const data = await response.json();
				if (data.iden) handleMenuItemClick('listSolpDeta', data.iden);
			} else {
				throw new Error('Error en la solicitud POST');
			}
		}
	}, [mail])

	useEffect(() => {
		const initializeComponent = async () => {
			const currentUrlParams = new URLSearchParams(window.location.search);
			const loaded = currentUrlParams.get('loaded');

			if (db && !loaded) {
				try {

					if (['CLTSTTHORINGENIERIA', 'CLPRDTHORINGENIERIA', 'CLPRDTHORSERVYASESORIAS', 'CLPRDTHORTRANSPYLOGISTICA'].includes(db)) {
						const response = await fetch(apiurl + 'queryAux', {
							method: 'POST',
							headers: { 'Content-Type': 'application/json' },
							body: JSON.stringify({ query: `UPDATE sys__user SET comp=(SELECT iden FROM sys__db WHERE sapDB='${db}') WHERE mail='${mail}'`, user: mail }),
						});

						if (response.ok) {

						} else {
							throw new Error('Error en la solicitud POST');
						}
					}

					currentUrlParams.set('loaded', '1');
					window.history.replaceState({}, '', '?' + currentUrlParams.toString());
					window.location.reload();

				} catch (error) {
					console.log('error al updatear la DB ', error);
				}
			}
			else if (billParam && mail) getMD5(billParam, 'bill')
			else if (smParam && mail) getMD5(smParam, 'sm')
			else if (spParam && mail) getMD5(spParam, 'sp');
		};

		initializeComponent();
	}, [mail, db, billParam, smParam, spParam, getMD5]);

	useEffect(() => {
		statusSAP();
	}, [statusSAP])


	return (
		<>
			{dspParam ? (<DSP dsp={dspParam} comp={compParam} />) :
				(docParam ? <DOC doc={docParam} comp={compParam} /> : <>
					<Helmet>
						<html lang="es" translate="no" />
						<body className={dark ? 'dark-mode' : 'light-mode'} style={styleString} translate="no" />
					</Helmet>
					<header>
						<menu>
						{/* eslint-disable-next-line jsx-a11y/heading-has-content */}
						<h1 data-icon='' onClick={() => handleMenuItemClick(null)}></h1>
						<h1 data-icon="."><figure style={{ backgroundImage: `url(${avat})` }}> </figure>{name}</h1>
						<h1 data-icon=''>
							<select onChange={(e) => setSelectComp(e.target.value)} value={comp ? comp : 0}>
								<option value="0">Sandbox</option>
								<option value="1">TIAN</option>
								<option value="2">TSAAN</option>
								<option value="3">TLOG</option>
							</select>
						</h1>
						<h1 data-icon='' onClick={openDialog}>Preferencias</h1>
						<h1 data-icon='' onClick={() => handleMenuItemClick('listUser')}>Usuarios</h1>
						<h1 data-icon='' onClick={() => handleMenuItemClick('listPosi')}>Cargos</h1>
						<h1 data-icon='' onClick={() => handleMenuItemClick('listCC')}>Centros de costo</h1>
						<h1 data-icon='' onClick={() => handleMenuItemClick('listInve')}>Inventario</h1>
						{/* Temporal: Katyana (215), Benjamin (1), Ignacio (100050001), Sebastian Sagardia (10). */}
						{/* Condición original: (isRole >= 3 || budg || canBill) */}
						{(isRole >= 3 && [215, 1, 100050001, 10].includes(Number(iden))) ? <h1 data-icon='' onClick={() => handleMenuItemClick('listBudg')}>Presupuesto</h1> : <></>}
						<h1 data-icon='' onClick={() => handleMenuItemClick('listSolp')}>Solicitudes</h1>
						<h1 data-icon='' onClick={() => handleMenuItemClick('listOrde')}>Órdenes</h1>
						<h1 data-icon='' onClick={() => handleMenuItemClick('listInvoice')}>Facturas</h1>
						<h1 data-icon='' onClick={() => handleMenuItemClick('listTrac')}>Seguimiento</h1>
						{
							budg ? <h1 data-icon='' onClick={() => handleMenuItemClick('listLedger')}>Libro Mayor</h1> : <></>

						}
						<h1 data-icon='' onClick={() => handleMenuItemClick('manual')}>Manual</h1>
						<h1 data-icon='' onClick={handleLogout}>Salir</h1>
						</menu>
						<footer className={statSAP ? 'gre' : 'red'}>
							<h1 data-icon=''>SAP {statSAP ? 'Online' : 'Offline'}</h1>
						</footer>
					</header>
					{dialogOpen && (
						<orm-modal>
							<dialog open>
								<h2>Preferencias</h2>
								<table>
									<thead>
										<tr>
											<td><orm-icon></orm-icon> Modo oscuro</td>
											<td><input type="checkbox" onChange={handleCBX} checked={dark} /></td>
										</tr>
									</thead>
								</table>
								<table>
									<tbody>
										<tr>
											<td colSpan="3"><orm-icon></orm-icon> Fondo</td>
										</tr>
										<tr>
											{images.map((image, index) => (
												/* eslint-disable-next-line jsx-a11y/alt-text */
												index < 3 && (<td key={index}><img className="pref_bg" src={images[index]} onClick={() => changeImage(index)} /></td>)
											))}
										</tr>
										<tr>
											{images.map((image, index) => (
												/* eslint-disable-next-line jsx-a11y/alt-text */
												index >= 3 && (<td key={index}><img className="pref_bg" src={images[index]} onClick={() => changeImage(index)} /></td>)
											))}
										</tr>
									</tbody>
								</table>
								<table>
									<tfoot>
										<tr>
											<td></td>
											<td><input type="button" value="Aceptar" onClick={closeDialog} /></td>
										</tr>
									</tfoot>
								</table>
							</dialog>
						</orm-modal>
					)}
					{!isRole ? messageComponent : getComponent(selectedComponent)}
				</>)
			}
		</>
	);
}

export default App;
